import AbstractAPI from '../../common/AbstractAPI';
import SiteConstants from '../../common/SiteConstants/SiteConstants';
import { FolderFeedbackContent } from './types';

class FolderFeedbackAPI extends AbstractAPI {
  static async sendFeedback(
    content: FolderFeedbackContent & { uniqueId: string }
  ): Promise<Response> {
    const formData = {
      bin_unique_id: content.uniqueId,
      fname: content.firstName,
      lname: content.lastName,
      email: content.emailAddress,
      'bin-feedback': content.comments,
    };

    const url = SiteConstants.buildInstance().getSubmitFolderFeedbackRoute();
    const response = await this.request(
      url,
      this.buildFetchOptions('POST', formData)
    );

    if (response.status !== 200) {
      throw new Error(response.statusText);
    } else {
      return response;
    }
  }
}

export default FolderFeedbackAPI;
